import { Hero } from './Hero';
import { Wrapper, Contents, Sidebar, Copy, Form, Image } from './Hero.views';
Hero.displayName = "HeroBase";
Wrapper.displayName = "Hero.Wrapper";
Copy.displayName = "Hero.Copy";
Contents.displayName = "Hero.Contents";
Sidebar.displayName = "Hero.Sidebar";
Form.displayName = "Hero.Form";
Image.displayName = "Hero.Image";
export { Hero as default, Wrapper, Contents, Sidebar, Copy, Form, Image };